// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { GetScrollRestorationKeyFunction } from 'react-router';

let lastNonOverlayRoute: {
    pathname: string;
    key: string;
} | null = null;

type Handle = {
    isOverlay?: boolean;
};

export const getScrollRestorationKey: GetScrollRestorationKeyFunction = (location, matches) => {
    const lastMatch = matches[matches.length - 1];
    const secondToLastMatch = matches[matches.length - 2];

    if (
        (lastMatch?.handle as Handle)?.isOverlay
        && lastNonOverlayRoute
        && secondToLastMatch
        && lastNonOverlayRoute?.pathname === secondToLastMatch.pathname
    ) {
        return lastNonOverlayRoute.key;
    }

    lastNonOverlayRoute = {
        pathname: lastMatch.pathname,
        key: location.key,
    };
    return location.key;
};
